module.exports = __webpack_public_path__ + "media/images/front/about/header_sp-8eb0938a5ca8f560253d658b0781fee5.png";